import { SEO } from '@/components/SEO';

export function AccessibilityPage() {
  return (
    <>
      <SEO
        title="Accessibility Statement - Nestor"
        description="Our commitment to web accessibility and inclusive design."
      />

      <div className="container mx-auto px-4 py-20 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Accessibility Statement</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm">Last updated: January 24, 2026</p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Our Commitment</h2>
            <p>
              Nestor is committed to ensuring digital accessibility for people with disabilities.
              We are continually improving the user experience for everyone and applying the relevant
              accessibility standards.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Standards</h2>
            <p>
              We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA standards.
              These guidelines explain how to make web content more accessible for people with disabilities.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Measures</h2>
            <p>We take the following measures to ensure accessibility:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Include accessibility as part of our mission statement</li>
              <li>Integrate accessibility into our procurement practices</li>
              <li>Provide continual accessibility training for our staff</li>
              <li>Assign clear accessibility goals and responsibilities</li>
              <li>Employ formal accessibility quality assurance methods</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Features</h2>
            <p>Our platform includes the following accessibility features:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Keyboard navigation support</li>
              <li>Screen reader compatibility</li>
              <li>Sufficient color contrast</li>
              <li>Resizable text without loss of functionality</li>
              <li>Alternative text for images</li>
              <li>Clear and consistent navigation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Feedback</h2>
            <p>
              We welcome your feedback on the accessibility of Nestor. Please let us know if you
              encounter accessibility barriers:
            </p>
            <p>
              Email: accessibility@hrms.com<br />
              Phone: +1 (555) 123-4567
            </p>
            <p>
              We try to respond to feedback within 5 business days.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
